import { render, staticRenderFns } from "./TextResultsGainWeight.vue?vue&type=template&id=c2b55044&scoped=true&"
import script from "./TextResultsGainWeight.vue?vue&type=script&lang=js&"
export * from "./TextResultsGainWeight.vue?vue&type=script&lang=js&"
import style0 from "./TextResultsGainWeight.vue?vue&type=style&index=0&id=c2b55044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b55044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2b55044')) {
      api.createRecord('c2b55044', component.options)
    } else {
      api.reload('c2b55044', component.options)
    }
    module.hot.accept("./TextResultsGainWeight.vue?vue&type=template&id=c2b55044&scoped=true&", function () {
      api.rerender('c2b55044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/weight/contentParts/TextResultsGainWeight.vue"
export default component.exports